import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { SubscriptionProvider } from '../contexts/SubscriptionContext';
import AppShell from './AppShell';

function App() {
  return (
    <SubscriptionProvider>
      <Router>
        <div className="app">
          <AppShell />
        </div>
      </Router>
    </SubscriptionProvider>
  );
}

export default App;